import { createSelector } from 'reselect';
import get from 'lodash/get';

import { initialState } from './reducer';
import { createSelectFieldOptions } from '../../utils/common';

const selectRegisterDomain = state => state.Register || initialState;

const selectRegistrations = () =>
  createSelector(selectRegisterDomain, subState => get(subState, 'registrationsList.data'));
const selectRegistrationToken = () => createSelector(selectRegisterDomain, subState => get(subState, 'regToken'));
const selectProducts = () => createSelector(selectRegisterDomain, subState => get(subState, 'products'));
const selectRegistrationErrorMessage = () =>
  createSelector(selectRegisterDomain, subState => get(subState, 'regError'));
const selectRegistrationProfile = () => createSelector(selectRegisterDomain, subState => get(subState, 'regProfile'));

const selectSubscriptions = () => createSelector(selectRegisterDomain, subState => get(subState, 'subscriptions'));
const selectActiveRegistration = () =>
  createSelector(selectRegisterDomain, subState => get(subState, 'activeRegistration'));
const selectAgenciesListOptions = (withAllData = false) =>
  createSelector(selectRegisterDomain, subState => {
    const agencies = get(subState, 'searchAgencies.data', []);
    return createSelectFieldOptions(agencies, 'id', 'name', {}, withAllData);
  });

export {
  selectRegistrations,
  selectActiveRegistration,
  selectAgenciesListOptions,
  selectProducts,
  selectSubscriptions,
  selectRegistrationErrorMessage,
  selectRegistrationProfile,
  selectRegistrationToken,
};
